import { css } from '@emotion/css';
import { rotateAnimation, textWave } from 'constants/global.style';
import { colors } from 'constants/theme';
import { Game3rdTransferModel } from 'models/fundTransferModel';
import { IoReloadOutline } from 'react-icons/io5';

interface Props {
    gameData: Game3rdTransferModel;
    onLoadBalance: (gameData: Game3rdTransferModel, isReload: boolean, cb?: () => void) => void;
}
export function Game3rdTransfer(props: Props) {
    const { gameData, onLoadBalance } = props;

    return (
        <div className={styles.containerAll}>
            <div className={styles.gameItem}>
                <p className={styles.gameName}>{gameData.balancename.includes(',') ? gameData.balancename.replace(',', ' + ') : gameData.balancename}</p>
                <div className={styles.balance}>
                    {gameData.loading ? (
                        <div className={styles.loading}>
                            <span></span>
                            <span></span>
                            <span></span>
                        </div>
                    ) : (
                        gameData.msg || new Intl.NumberFormat().format(Number(gameData.balance))
                    )}
                </div>
            </div>

            <button type="button" className={styles.btnRefresh} onClick={() => onLoadBalance(gameData, true)}>
                <IoReloadOutline size={32} color={'#023639'} />
            </button>
        </div>
    );
}

const styles = {
    containerAll: css`
        display: flex;
        border-radius: 8px;
        overflow: hidden;
        height: 80px;
        /* align-items: center; */
    `,
    gameItem: css`
        background-repeat: no-repeat;
        position: relative;
        border-right: 1px solid #ffad33;
        background-image: linear-gradient(to bottom, #023639, #056369, #023639);
        position: relative;
        width: 70%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding-left: 5px;
        gap: 5px;
        p {
            font-size: 12px;
            color: #fff;
        }
    `,
    btnRefresh: css`
        width: 30%;
        display: flex;
        padding: 4px;
        cursor: pointer;
        background-image: linear-gradient(to bottom, #ddca8c, #fcf3d4, #ddca8c, #fcf3d4, #ddca8c);
        justify-content: center;
        align-items: center;
        &.rotating {
            pointer-events: none;
            animation: ${rotateAnimation} 0.8s linear infinite;
        }
        img {
            width: 18px;
            height: 18px;
            opacity: 0.8;
        }
    `,
    gameName: css`
        /* margin-bottom: 8px; */
    `,
    msgAlert: css`
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
        color: ${colors.red};
        height: 19px;
    `,
    balance: css`
        color: ${colors.yellow};
        font-family: 'UTM AvoBold', sans-serif;
        font-weight: bold;
        display: inline-block;
        font-size: 12px;
        background: -webkit-linear-gradient(28deg, #ddca8c, #fcf3d4, #ddca8c, #fcf3d4, #ddca8c);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        /* line-height: 1.5; */
    `,
    loading: css`
        display: flex;
        align-items: center;
        height: 19px;
        span {
            width: 6px;
            height: 6px;
            background: ${colors.yellow};
            border-radius: 8px;
            animation: ${textWave} 1s ease-in-out infinite;
            display: inline-block;
            margin-left: 2px;
            &:nth-child(2) {
                animation-delay: 0.1s;
            }
            &:nth-child(3) {
                animation-delay: 0.2s;
            }
        }
    `,
};
